import { removeNulls } from 'utils/Object.utils';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type InvestorDeduction = {
  id?: string;
  [key: string]: any;
};

export type InvestorDeductionsState = Record<string, any>;

const initialState: InvestorDeductionsState = {};

const investorDeductionsReducer = (
  state: InvestorDeductionsState = initialState,
  action: ReducerAction
): InvestorDeductionsState => {
  switch (action.type) {
    case 'INVESTOR_DEDUCTION_ADD': {
      const { deduction } = action;
      return {
        ...state,
        [deduction.id]: deduction,
      };
    }
    case 'INVESTOR_DEDUCTION_UPDATE': {
      const { deduction } = action;
      return {
        ...state,
        [deduction.id]: deduction,
      };
    }
    case 'INVESTOR_DEDUCTION_DELETE': {
      const { deductionId } = action;
      return removeNulls({
        ...state,
        [deductionId]: null,
      }) as InvestorDeductionsState;
    }
    default:
      return state;
  }
};
export default investorDeductionsReducer;
